import request from '../utils'

const performanceApi = {
    performanceList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/performance`)
        const res = await req;
        return res.body;
    }, 
    performanceDetail: async (modelingId, performance) => {
        const req = request.get(`/api/modeling/${modelingId}/performance/${performance}`)
        const res = await req;
        return res.body;
    },
    performanceUpdate: async (modelingId, performance) => {
        const req = request.put(`/api/modeling/${modelingId}/performance/${performance.id}`).send(performance);
        const res = await req;
        return res.body;
    },
    performanceCreate: async (modelingId, performance) => {
        const req = request.post(`/api/modeling/${modelingId}/performance`).send(performance);
        const res = await req;
        return res.body;
    },
    performanceDelete: async (modelingId, performanceId) => {
        const req = request.delete(`/api/modeling/${modelingId}/performance/${performanceId}`);
        await req;
    }
};

export default performanceApi